import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  useTheme,
  Button,
  Modal,
  TextField,
  DialogActions,
  DialogContent,
  DialogContentText,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
  IconButton,
} from "@mui/material";

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

// import { styled } from '@mui/material/styles';

import { DataGrid, GridApi } from "@mui/x-data-grid";

import { useGetReligionsQuery, useCreateReligionsMutation, useUpdateReligionMutation, useDeleteReligionMutation } from "state/api";
import { Header } from "components";




const Religions = () => {

  const { data, isLoading, refetch } = useGetReligionsQuery();


  const [createReligion] = useCreateReligionsMutation();
  const [updateReligion] = useUpdateReligionMutation();
  const [deleteReligion] = useDeleteReligionMutation();


  const theme = useTheme();

  const gridApiRef = useRef(null);

  useEffect(() => {
    // Access grid API when it's ready
    if (gridApiRef.current) {
      const api = gridApiRef.current;
      // Perform any actions needed with the grid API here
      // For example, you could set initial selected rows:
      api.setSelectedRows([0]);
    }
  }, [gridApiRef]);

  // data columns
  const columns = [
    // {
    //   field: "_id",
    //   headerName: "ID",
    //   flex: 1,
    // },
    {
      field: "name",
      headerName: "Religion Title",
      flex: 1,
      // editable: true,
    },
    // {
    //   field: "description",
    //   headerName: "Religion Description",
    //   flex: 1,
    //   // editable: true,
    // },
   
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      renderCell: (params) => {
        const { _id } = params.row;
        return (
          <div>
            <IconButton
              color="primary"
              aria-label="edit"
              onClick={() => handleOpenEdit(_id)}
            >
              <EditIcon sx={{ color: 'white' }} />
            </IconButton>
            <IconButton
              color="error"
              aria-label="delete"
              onClick={() => handleDeleteReligion(_id)}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const [open, setOpen] = useState(false);
  const [name, setname] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [description, setdescription] = useState("");
  const [selectedFileType, setSelectedFileType] = useState("image/*"); // Initial file type (image)

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleFileTypeChange = (event) => {
    setSelectedFileType(event.target.value);
  };

  // const handleFileChange = (event) => {
  //   setSelectedFile(event.target.files[0]);
  // };

  // const handleSubmit = async () => {
  //   // Implement validation logic here
  //   if (!name || !selectedFile) {
  //     // Handle missing data errors
  //     return;
  //   }

  //   // Implement upload logic (e.g., using a library like Axios)
  //   // ...

  //   // Update Religion data in your application state (based on your data structure)
  //   // ...
  // };

  const [user, setUser] = useState(null);
  const [nameError, setnameError] = useState(null);
  const [religionCategory, setreligionCategory] = useState("Religion"); // Initial selection
  const [religionCategoryError, setreligionCategoryError] = useState(null);
  const [selectedFileError, setSelectedFileError] = useState(null);
  const [descriptionError, setdescriptionError] = useState(null);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false); // State for loading indicator
  const [selectedEditRowData, setSelectedEditRowData] = useState(null); // Add this state to store the selected row's data

  const [religionEditError, setreligionEditError] = useState(null);


  // New state to track the modified fields
  const [modifiedFields, setModifiedFields] = useState({});

  const handlenameChange = (event) => {
    setname(event.target.value);
    // Update the modified fields
    // setModifiedFields({ ...modifiedFields, name: selectedEditRowData.name });
    setModifiedFields({ ...modifiedFields, name: event.target.value });

    setnameError(event.target.value ? null : "Enter religion name");
  };

  const handleCategoryChange = (event) => {
    setreligionCategory(event.target.value);
    // Update the modified fields
    // setModifiedFields({ ...modifiedFields, religionCategory: selectedEditRowData.religionCategory });
    setModifiedFields({ ...modifiedFields, religionCategory: event.target.value });

    setreligionCategoryError(event.target.value ? null : "Please select a category");
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    // Update the modified fields
    // setModifiedFields({ ...modifiedFields, selectedFile: selectedEditRowData.selectedFile });
    setModifiedFields({ ...modifiedFields, selectedFile: event.target.files[0] });

    setSelectedFileError(event.target.files.length > 0 ? null : "Select a file");
  };

  const handledescriptionChange = (event) => {
    setdescription(event.target.value);
    // Update the modified fields
    // setModifiedFields({ ...modifiedFields, description: selectedEditRowData.description });
    setModifiedFields({ ...modifiedFields, description: event.target.value });

    setdescriptionError(event.target.value ? null : "Enter religion description");
  };


  const handleSubmit = async () => {
    console.log("working");
    // ... other logic

    if (!name) {
      setnameError("Enter religion name");
      return;
    }


    // if (!description) {
    //   setdescriptionError("Enter religion description");
    //   return;
    // }

    setIsLoadingSubmit(true); // Start loading before asynchronous operations
    const updateData = {
        name: name,
        description: description,
      };
      console.log("206 working");
      await createReligion(updateData);

    setIsLoadingSubmit(false); // Stop loading after data is created

    setOpen(false); // Close the modal after successful submission

    refetch();
  };


  const handleOpenEdit = (id) => {

    const selectedRow = data.find((row) => row._id === id);

    if (selectedRow) {
      setname(selectedRow.name || "");
      setdescription(selectedRow.description || "");

      setSelectedEditRowData(selectedRow);

      // Set the modified fields to an empty object initially
      setModifiedFields({});

      setOpen(true);
    }
  };


  const handleEditSubmit = async () => {
    // Only send the modified fields to the API
    if (Object.keys(modifiedFields).length > 0) {
   

      setIsLoadingSubmit(true); // Start loading before asynchronous operations


        const { selectedFile, ...rest } = modifiedFields;


        const editedReligionData = {
          id: selectedEditRowData._id,
          ...modifiedFields,
        };


        await updateReligion(editedReligionData);

      setIsLoadingSubmit(false); 

      setOpen(false); 
      refetch();
    }
    else {
      setreligionEditError("Edit a value first");
      return;
    }

    // Rest of the code...
  };

  const handleDeleteReligion = async (id) => {
    if (window.confirm("Are you sure you want to delete this religion?")) {
      try {
        // await deleteReligion.mutateAsync(id);
        // await deleteReligion(id);
        await deleteReligion({ id: id });
        refetch(); // Reload to reflect changes in the UI
      } catch (error) {
        console.error("Error deleting Religion:", error);
      }
    }
  };

  return (
    <Box m="1.5rem 2.5rem">
      {/* Header */}
      {/* <Header title="Religion" subtitle="List of Religion" /> */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="Religion" subtitle="List of Religion" />
        <Button variant="contained" color="primary" size="medium" onClick={handleOpen}>
          {'Add Religion'}
        </Button>
      </Box>

      {/* Content */}
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButtom-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        {/* Grid table */}
        <DataGrid
          loading={isLoading || !data}
          getRowId={(row) => row._id}
          rows={data || []}
          columns={columns}
        // editMode="row"
        // // Handle row edit functionality (optional)
        // onRowEditCommit={({ id, ...newData }) => {
        //   // Update the edited data using the updateReligion mutation
        //   // updateReligion.mutateAsync({ id, ...newData });
        // }}
        // apiRef={gridApiRef}
        />
      </Box>


      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          minWidth: 500, // Adjust the minimum width for your modal
          p: 4, // Add padding inside the modal
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper', // Set white background
          borderRadius: 2,           // Add rounded borders (adjust the value)
          boxShadow: 24
        }}>

          <DialogContent>
            {/* Error messages */}
            {nameError && <Typography variant="caption" color="error">{nameError}</Typography>}
            {selectedFileError && <Typography variant="caption" color="error">{selectedFileError}</Typography>}
            {religionEditError && <Typography variant="caption" color="error">{religionEditError}</Typography>}

            <DialogContentText>
              {!selectedEditRowData ? "Add a new religion" : "Edit religion"}
            </DialogContentText>
            {/* <TextField
              label="religion Name"
              value={name}
              onChange={(event) => setname(event.target.value)}
              fullWidth
              margin="normal"
            /> */}
            <TextField
              label="religion Name"
              value={name}
              onChange={handlenameChange}
              error={!!nameError} // Set error prop based on error state
              helperText={nameError} // Set helper text for error display
              fullWidth
              margin="normal"
            />
            <br />
        
            <br />
            {/* <InputLabel id="demo-simple-select-label">File Type</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedFileType}
              label="File Type"
              onChange={handleFileTypeChange}
            >
              <MenuItem value={"image/*"}>Image</MenuItem>
              <MenuItem value={"video/*"}>Video</MenuItem>
            </Select>
            <br /> */}
          
            {/* <TextField
              label="religion Description"
              value={description}
              onChange={handledescriptionChange}
              error={!!descriptionError} // Set error prop based on error state
              helperText={descriptionError} // Set helper text for error display
              fullWidth
              multiline  // Enable multiline
              rows={4}    // Set the number of rows to 4
              margin="normal"
    
            /> */}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            {/* <Button onClick={handleSubmit} color="primary">
              Save
            </Button> */}

            <Button onClick={!selectedEditRowData ? handleSubmit : handleEditSubmit} color="primary" disabled={isLoadingSubmit}>
              {isLoadingSubmit ? <CircularProgress size="medium" style={{ width: 20, height: 20, color: 'white' }} /> : 'Save'}
              {/* Save */}
            </Button>

          </DialogActions>
        </Box>
      </Modal>
    </Box>
  );
};

export default Religions;
